import React, {FC, memo} from 'react'

type TComponentObjectView = {
    value: any
}

const isObject = (v: any) => v && typeof v === 'object' && !Array.isArray(v)

const normalizeValue = (v: any) => {
    if (v === null || v === undefined || v === '') return '—'

    if (Array.isArray(v)) {
        return v
            .map((x) => {
                if (isObject(x) && 'title' in x && 'value' in x) return (x as any).title ?? '—'
                return String(x)
            })
            .join(', ')
    }

    if (isObject(v) && 'title' in v && 'value' in v) {
        return (v as any).title ?? '—'
    }

    if (typeof v === 'boolean') return v ? 'Да' : 'Нет'

    return String(v)
}

const getRowTitle = (row: any) => {
    if (!row) return 'Элемент'

    if (row.text) return row.text
    if (row.title) return row.title
    if (row.name) return row.name

    return 'Элемент'
}

const ComponentObjectView: FC<TComponentObjectView> = memo(({value}) => {
    const rows = Array.isArray(value) ? value : []

    if (!rows.length) {
        return <div className='componentObjectView_empty'>—</div>
    }

    return (
        <div className='componentObjectView'>
            {rows.map((row, rowIndex) => {
                const rowObj = isObject(row) ? row : null
                const entries = rowObj ? Object.entries(rowObj) : []

                return (
                    <div className='componentObjectView_row' key={(rowObj as any)?.id ?? rowIndex}>
                        <div className='componentObjectView_rowHeader'>
                            <div className='componentObjectView_rowTitle'>
                                {rowIndex + 1}. {getRowTitle(rowObj)}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
})

export default ComponentObjectView
